import BeelditSwitchInput from "@beeldit/core/components/BeelditSwitchInput";
import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { Pencil, Plus, Trash } from "@phosphor-icons/react";
import { t } from "i18next";
import { min } from "lodash";
import UserSelector from "@main/modules/beeldit/user-and-access/users/components/UserSelector";
import ColorSelector from "./components/ColorSelector";
import ColorDisplay from "./components/ColorDisplay";

const config = {
  modelName: "therapist",
  modelPluralName: "therapists",
  endpoint: "therapists",
  indexQueryParams: {
    relations: ["user"],
  },
  tableConfig: {
    index: null,
    actions: [
      {
        name: TableAction.CREATE,
        label: "create",
        showLabel: true,
        allowed: true,
        show: true,
        action: null,
        icon: <Plus size={20} />,
      },
    ],
    rowActions: [
      {
        name: RowAction.EDIT,
        label: "edit",
        icon: <Pencil size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("edit", element);
        },
      },
      {
        name: RowAction.DELETE,
        label: "delete",
        icon: <Trash size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("delete", element);
        },
      },
    ],
    rowConfiguration: {
      class: (element: any) => {
        return null;
      },
    },
    columns: [
      {
        name: "id",
        label: "#",
        key: "id",
        type: "number",
        show: true,
        allowOrder: true,
      },
      {
        name: "full_name",
        label: "full_name",
        key: "full_name",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "user_email",
        label: "email",
        key: "user.email",
        type: "string",
        show: true,
        allowOrder: false,
      },
      {
        name: "color",
        label: "color",
        key: "color",
        type: "custom",
        show: true,
        allowOrder: false,
        customRender: (element: any) => <ColorDisplay color={element.color} />,
      },
    ],
    pagination: {
      enabled: true,
      back: true,
    },
  },
  filterConfig: {
    type: "object",
    properties: {
      search: {
        type: "string",
      },
    },
  },
  filterUIConfig: {
    uiScheme: {
      className: "filters-container",
      search: {
        "ui:options": {
          label: false, // Oculta el título del campo
          placeholder: "Buscar...",
        },
      },
    },
    widgets: {},
  },
  formSchema: {
    type: "object",
    properties: {
      // Name
      name: {
        type: ["string", "null"],
        title: t("name"),
      },
      // Surnames
      first_lastname: {
        type: ["string", "null"],
        title: t("therapist_first_lastname"),
      },
      // Second surname
      second_lastname: {
        type: ["string", "null"],
        title: t("second_lastname"),
      },
      // Usuario asociado
      user_id: {
        type: ["integer", "null"],
        title: "Usuario asociado",
      },
      // Color identificativo
      color: {
        type: ["string", "null"],
        title: "Color identificativo",
        enum: [
          "#D4F1D4",
          "#D4E9FB",
          "#FFE4CC",
          "#EDD4ED",
          "#FFF9CC",
          "#E4D4FF",
          "#D4FFED",
          "#FFD4E4",
          "#EDEDC4",
          "#D4F1FF",
        ],
      },
    },
  },
  uiFormSchema: {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    "ui:order": [
      "name",
      "first_lastname",
      "second_lastname",
      "user_id",
      "color",
    ],
    user_id: {
      "ui:widget": UserSelector,
      "ui:placeholder": "Seleccionar usuario...",
    },
    color: {
      "ui:widget": ColorSelector,
      "ui:placeholder": "Seleccionar color identificativo...",
    },
    colsSchema: [
      {
        cols: "col-12",
        elements: [
          [
            {
              name: "name",
              cols: "col-6",
            },
            {
              name: "first_lastname",
              cols: "col-6",
            },
          ],
          [
            {
              name: "second_lastname",
              cols: "col-6",
            },
            {
              name: "user_id",
              cols: "col-6",
            },
          ],
          [
            {
              name: "color",
              cols: "col-6",
            },
          ],
        ],
      },
    ],
  },
};
export default config;
